// extracted by mini-css-extract-plugin
export default {"card":"AdminDashboard_card__VS5yF"};